if (window.storeSwitcherSettings) {
  const settings = window.storeSwitcherSettings;

  const thisSelectedTitle = settings.selectedTitle;
  const thisSelectedFlagSvg = settings.selectedFlagSvg;
  let thisSelectedImage = '';
  let thisFlagSvg = '';
  let thisFullName = '';

  if (settings.selectedImage.length > 0) {
    thisSelectedImage = settings.selectedImage;
  }

  let storesData = settings.storesData;

  let thisShopUrl = `${Shopify.routes.url}`;

  // Fallbacks for development stores.
  if (thisShopUrl.includes('kazam-development')) {
    // UK Dev
    thisShopUrl = 'https://ukstore.hermanmiller.com/'
    // HK Dev
  } else if (thisShopUrl.includes('kazam-apmea-test')) {
    thisShopUrl = 'https://www.hermanmiller.hk/'
  }

  const currentlyStore = storesData.filter(el => el.link.indexOf(thisShopUrl) !== -1),
    europeData = storesData.filter(el => el.area == 'a'),
    asiaPacificData = storesData.filter(el => el.area == 'b'),
    northAmericaData = storesData.filter(el => el.area == 'c'),
    othersStore = storesData.filter(el => el.link.indexOf(thisShopUrl) === -1);

  const areaEuropeHeading = settings.areas.a,
    asiaPacificHeading = settings.areas.b,
    northAmericaHeading = settings.areas.c;

  const $storeToggle = jQuery('.js-country-selector-generate-flag');
  $storeList = jQuery('.switcher-store-list-js');

  const thisStoreData = currentlyStore[0],
    thisStoreName = thisStoreData.name,
    thisStoreCode = thisStoreData.code,
    thisStoreLink = thisStoreData.link,
    thisStoreCurrency = thisStoreData.currency,
    thisStoreFullName = thisStoreData.title,
    thisStoreFlag = thisStoreData.flag_svg;

  thisFullName = thisStoreFullName,
    thisFlagSvg = thisStoreFlag;

  if (thisSelectedTitle != '') {
    thisFullName = thisSelectedTitle;
  }

  if (thisSelectedFlagSvg != '') {
    thisFlagSvg = thisSelectedFlagSvg.replace('<svg ', '<svg class="absolute inset-0 w-full h-full scale-[1.45]" ');
  } else if (thisSelectedImage != '') {
    thisFlagSvg = `<img class="absolute inset-0 w-full h-full scale-[1.45]" src="${thisSelectedImage}" alt="${thisFullName}" />`;
  }

  let thisStoresRequestPath = window.location.pathname;

  if (thisStoresRequestPath.length == 1) {
    thisStoresRequestPath = '';
  }

  const buildStoreToggle = () => {
    const classes = "block relative w-[16px] h-[16px] border border-solid border-white outline outline-solid outline-grey-10 rounded-full overflow-hidden";

    if (currentlyStore.length) {
      $storeToggle.append(`<span class="${classes}">${thisFlagSvg}</span><span class="max-lg:hidden">${thisFullName}</span>`);
    } else {
      $storeToggle.append(`<span><span class="${classes}">${thisSelectedFlagSvg}</span><span class="max-lg:hidden">${thisSelectedTitle}</span></span>`);
    }
  }

  const buildStoreList = () => {
    renderList(europeData, areaEuropeHeading);
    renderList(asiaPacificData, asiaPacificHeading);
    renderList(northAmericaData, northAmericaHeading);
  }

  const renderList = (listData, heading) => {
    if (listData.length) {
      let html = `
        <div class="col-span-1">
          <h6 class="text-[13px] max-lg:pb-[20px] max-lg:border-b max-lg:border-solid max-lg:border-grey-110 select-none text-left leading-1 tracking-1 mb-[16px]">
            ${heading}
          </h6>
          <ul class="flex flex-col gap-y-[8px]">
      `;

      listData.forEach(el => {
        let elRequestPath = thisStoresRequestPath;

        if (el.is_shopify_store == false) {
          elRequestPath = '';
        }

        const link = el.link.replace(/\/$/, '') + elRequestPath + '?storeRedirect=' + el.name;
        html += `
          <li>
            <a
              href="${link}"
              class="hover:opacity-50 transition-opacity select-none cursor-pointer leading-none text-[13px] tracking-1 flex items-center gap-x-[8px]"
              tabindex="-1"
            >
              <span class="block relative w-[16px] h-[16px]">
                ${el.flag_svg}
              </span>
              ${el.title} (${el.currency})
            </a>
          </li>
        `;
      });

      html += `
          </ul>
        </div>
      `;
      $storeList.append(html);
    }
  }

  const initSwitcherStore = () => {
    buildStoreToggle();
    buildStoreList();
  }

  initSwitcherStore();
}
